import { getConfig } from './getConfig'
import { getExportedEnv } from './getExportedEnv'
import { getProcessEnv } from './getProcessEnv'

export const env = (() => {
  const processenv = getProcessEnv()
  // console.log('process env', processenv)
  const config = getConfig()
  // console.log('config env', config)
  const exported = getExportedEnv()
  // console.log('exported env', exported)
  const output = {
    ...processenv,
    ...config,
    ...exported,
  }
  // console.log('full env', output)
  return output
})() as any
